/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {CodeFilterModel} from './code-filter.model';

export class CodeFilterUtil {
    static setCodeChecked(code: CodeFilterModel): void {
        code.indeterminate = false;
        code.checked = true;
    }

    static setCodeUnchecked(code: CodeFilterModel): void {
        code.indeterminate = false;
        code.checked = false;
    }

    static setCodeIndeterminate(code: CodeFilterModel): void {
        code.checked = false;
        code.indeterminate = true;
    }
}
